export const LastOrdersType = {
  IGetLastOrdersService: Symbol("IGetLastOrdersService"),
};
